export default "__VITE_ASSET__CVKjvWK$__"